
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import CollapseItem from '@/components/collapse.vue';
import Dialog from '@/components/dialog.vue';
import Message from '@/components/message.vue';

import UploadImg from '@/components/upload-img.vue';
import {
	imgHost
} from '@/utils/config';

import {
	pagesContentConfig,
	pagesContentConfigSave
} from "@/api/material"
@Component({
	name: '',
	components: {
		PageFooter,
		CollapseItem,
		'slz-dialog': Dialog,
		'slz-message': Message,
		UploadImg
	}
})

export default class ProductList extends Vue {
	private pageloading = false;
	private imgUrl: string = imgHost;

	private formData: any = {
		HomePageLeftTopLogo: [],// (string, optional): 首页左上角LOGO,
		ProductDetailPanicBuyBaseMap: [],// (string, optional): 商品详情页抢购底图,
		MemberCenterBackgroundImgUrl: [],// (string, optional): 个人中心资料背景图,
		MembershipBenefitsBackgroundImgUrl: [],// (string, optional): 会员权益背景图,
		DecorationComponentsColor: '',// (string, optional): 装修组件颜色,
		SomePagesColor: '',// (string, optional): 部分页面颜色,
		HomePageSideLevitationIconOne: [],// (string, optional): 首页侧边悬浮图标1,
		HomePageSideLevitationIconTwo: [],// (string, optional): 首页侧边悬浮图标2,
		HomePageSideLevitationIconThree: [],// (string, optional): 首页侧边悬浮图标3,
		HomePageSideLevitationIconFour: [],// (string, optional): 首页侧边悬浮图标4,
		BottomMenuHomePageNoCheckedImgUrl: [],// (string, optional): 底部菜单-首页未选中,
		BottomMenuHomePageCheckedImgUrl: [],// (string, optional): 底部菜单-首页选中,
		BottomMenuCartNoCheckedImgUrl: [],// (string, optional): 底部菜单-购物车未选中,
		BottomMenuCartCheckedImgUrl: [],// (string, optional): 底部菜单-购物车选中,
		BottomMenuFansSayNoCheckedImgUrl: [],// (string, optional): 底部菜单-肉粉说未选中,
		BottomMenuFansSayCheckedImgUrl: [],//: ''// (string, optional): 底部菜单-肉粉说选中,
		BottomMenuMineNoCheckedImgUrl: [],// (string, optional): 底部菜单-我的未选中,
		BottomMenuMineCheckedImgUrl: [],// (string, optional): 底部菜单-我的选中,
		BottomMenuCheckedTextColor: '',// (string, optional): 底部菜单栏选择的文案色值
	}

	private mounted() {
		this.getData();
	}

	// 上传图片成功回调
	private uploadSucess(list: any, key: string) {
		this.formData[key] = list
	}

	private async getData() {
		try {
			this.pageloading = true
			let res = await pagesContentConfig({})
			if (res.IsSuccess) {
				let form = res.Result
				
				for (let item in this.formData){
					if (Array.isArray(this.formData[item])){
						if (form[item]){
							this.formData[item] = [form[item]]
						}
					}else{
						this.formData[item] = form[item]
					}
				}

			}
		} finally {
			this.pageloading = false
		}
	}
	private async handleSubmit() {
		console.log(this.formData)

		let obj = {};
		let showError = false;
		for (let item in this.formData){
			if (Array.isArray(this.formData[item])){
				if (!this.formData[item].length){
					showError = true;
				}else{
					obj[item] = this.formData[item][0]
				}
			}else{
				if (!this.formData[item]){
					showError = true;
				}else{
					obj[item] = this.formData[item]
				}
			}
		}

		if (showError){
			this.$message.error('存在未配置内容，请检查！');
			return;
		}

		try {
			this.pageloading = true
			let res = await pagesContentConfigSave(obj)
			if (res.IsSuccess) {
				this.$message.success('保存成功');
				this.getData();
			}
		} finally {
			this.pageloading = false
		}
	}
}
